// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { cartPageTemplateBreakpoint } from "@keller/App/Components/Cart/CartPageTemplate";
import { checkoutPageContainerStyles } from "@keller/App/Widgets/Checkout/CheckoutPageContainer";
import { DivWrapper } from "@keller/XDL/constants";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

checkoutPageContainerStyles.headerTitle = {
    variant: "h1",
};

checkoutPageContainerStyles.cartApprovalMessagesWrapper = {
    css: css`
        width: 100%;
        margin-bottom: 24px;
        margin-top: 12px;
        & ${DivWrapper} > div > ${TypographyStyle} {
            margin-bottom: 24px;
        }
    `,
};

checkoutPageContainerStyles.cartPageTemplateStyles = {
    headerSection: {
        css: css`
            margin-bottom: 8px;
        `,
    },
    mainSection: {
        css: css`
            grid-row: 2/3;
            ${xScreen("lte", cartPageTemplateBreakpoint)} {
                grid-row: 2/3;
                margin-top: 0;
            }
            ${xScreen("lte", "xs")} {
                grid-row: 3/4;
            }
        `,
    },
    totalSection: {
        css: css`
            margin-top: -62px;
            grid-row: 2/3;
            ${xScreen("lte", cartPageTemplateBreakpoint)} {
                grid-row: 4/5;
                margin-top: 48px;
            }
            ${xScreen("lte", "xs")} {
                grid-row: 5 / 6;
                &.review-step {
                    grid-row: 2 / 3;
                    margin-top: 32px;
                }
            }
        `,
    },
};
